import axios from 'shared/utils/axios'
import { organizationSettingType } from 'pages/CustomizeScoreboard/model/organizationSetting'
import { call, takeLatest, put } from 'redux-saga/effects'
import { getOrganizationSettings, setOrganizationInformation } from './reducer'

function* GetOrganizationSettings() {
  try {
    const response: organizationSettingType = yield call(axios.request, {
      url: `/setting/organization`,
    })

    yield put(setOrganizationInformation(response))
  } catch (err) {
    console.error(err)
  }
}

export default function* rootSaga() {
  yield takeLatest(getOrganizationSettings.type, GetOrganizationSettings)
}
